import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  FilterProps,
  PagedResponse,
} from '../../core/store/general/models/general';
import { createParams } from '../../core/store/utils/utils';
import {
  IAssociatedEntities,
  IVulnerability,
  IVulnerabilityAsset,
  IVulnerabilityOccurence,
  IVulnerabilityOverview,
} from '../../core/store/vulnerabilities/models/Vulnerability';

@Injectable({
  providedIn: 'root',
})
export class VulnerabilitiesService {
  private baseApiUrl: string = environment.API_BASE_URL;

  constructor(private readonly http: HttpClient) {}

  getVulnerabilities(
    props: FilterProps,
  ): Observable<PagedResponse<IVulnerability>> {
    return this.http.get<PagedResponse<IVulnerability>>(
      `${this.baseApiUrl}/vulnerabilities${createParams(props)}`,
    );
  }

  getVulnerabilityById(id: string): Observable<IVulnerabilityOverview> {
    return this.http.get<IVulnerabilityOverview>(
      `${this.baseApiUrl}/vulnerabilities/${id}`,
    );
  }

  getVulnerabilityAssociatedEntities(
    vulnerabilityId: string,
  ): Observable<IAssociatedEntities> {
    const params = new HttpParams().set('vulnerabilityId', vulnerabilityId);
    return this.http.get<IAssociatedEntities>(
      `${this.baseApiUrl}/vulnerabilities/associated-entities`,
      { params },
    );
  }

  resolveVulnerability(vulnerabilityId: string): Observable<IVulnerability> {
    return this.http.post<IVulnerability>(
      `${this.baseApiUrl}/vulnerabilities/resolve`,
      {
        vulnerabilityId,
      },
    );
  }

  unresolveVulnerability(vulnerabilityId: string): Observable<IVulnerability> {
    return this.http.post<IVulnerability>(
      `${this.baseApiUrl}/vulnerabilities/un-resolve`,
      {
        vulnerabilityId,
      },
    );
  }

  getVulnerabilitiesAssets(): Observable<IVulnerabilityAsset[]> {
    return this.http.get<IVulnerabilityAsset[]>(
      `${this.baseApiUrl}/vulnerabilities/assets`,
    );
  }

  calculateVulnerabilityRisk(
    vulnerabilityId: string,
  ): Observable<IVulnerability[]> {
    return this.http.post<IVulnerability[]>(
      `${this.baseApiUrl}/vulnerabilities/calculate-risk`,
      {
        vulnerabilityId,
      },
    );
  }

  getVulnerabilityOccurences(
    vulnerabilityId: string,
    props: FilterProps,
  ): Observable<PagedResponse<IVulnerabilityOccurence>> {
    return this.http.get<PagedResponse<IVulnerabilityOccurence>>(
      `${this.baseApiUrl}/vulnerabilities/${vulnerabilityId}/occurrences${createParams(props)}`,
    );
  }

  resolveOccurrence(
    vulnerabilityId: string,
    occurrenceId: string,
  ): Observable<IVulnerability> {
    return this.http.put<IVulnerability>(
      `${this.baseApiUrl}/vulnerabilities/${vulnerabilityId}/occurrence/${occurrenceId}/resolve `,
      {
        vulnerabilityId,
        occurrenceId,
      },
    );
  }

  unResolveOccurrence(
    vulnerabilityId: string,
    occurrenceId: string,
  ): Observable<IVulnerability> {
    return this.http.put<IVulnerability>(
      `${this.baseApiUrl}/vulnerabilities/${vulnerabilityId}/occurrence/${occurrenceId}/un-resolve `,
      {
        vulnerabilityId,
        occurrenceId,
      },
    );
  }
}
